<template>
  <div>
    <header id="header">
      <div class="container">
        <div class="row">
          <div class="col-6">
            <a href="/" class="logo">
              <img src="/overt/img/logo.svg" />
            </a>
          </div>
          <div class="col-6 text-right">
            <router-link tag="a" to="login" class="login">
              <span>
                <img src="/overt/img/login.svg" />
                Login
              </span>
            </router-link>
          </div>
        </div>
      </div>
    </header>

    <section class="hero">
      <div class="container h-100">
        <div class="row h-100">
          <div class="col-xl-4 col-lg-8 align-self-center">
            <h2>{{ lang.header }}</h2>
            <p>{{ lang.introductory }}</p>
          </div>
        </div>
      </div>

      <div class="illustration-1">
        <div class="img"></div>
        <div class="border"></div>
      </div>

      <div class="illustration-2">
        <div class="img"></div>
        <div class="border"></div>
      </div>
    </section>

    <section class="action">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h3 class="mb-4">{{ lang.header_services }}</h3>
          </div>
          <div class="col-lg-3">
            <div class="card inleveren">
              <h4>{{ lang.card_return_car.header }}</h4>
              <div class="card-footer">
                <a
                  @click="onAccodionItemClick"
                  class="btn btn-sm btn-secondary"
                  data-toggle="collapse"
                  href="#inleveren"
                  aria-expanded="false"
                  aria-controls="inleveren"
                  >{{ lang.card_return_car.btn }}</a
                >
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="card inleverlocaties">
              <h4>{{ lang.card_drop_off_location.header }}</h4>
              <div class="card-footer">
                <a
                  @click="onAccodionItemClick"
                  class="btn btn-sm btn-secondary"
                  data-toggle="collapse"
                  href="#search"
                  aria-expanded="false"
                  aria-controls="search"
                  >{{ lang.card_drop_off_location.btn }}</a
                >
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="card doorhuren">
              <h4>{{ lang.card_rental_extension.header }}</h4>
              <div class="card-footer">
                <a
                  @click="onAccodionItemClick"
                  class="btn btn-sm btn-secondary"
                  data-toggle="collapse"
                  href="#rental-extension"
                  aria-expanded="false"
                  aria-controls="rental-extension"
                  >{{ lang.card_rental_extension.btn }}</a
                >
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="card contact">
              <h4>{{ lang.card_contact.header }}</h4>
              <div class="card-footer">
                <a class="btn btn-sm btn-secondary" href="#contact">{{
                  lang.card_contact.btn
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section ref="accordion" class="accordion" id="accordion-parrent">
      <div class="container">
        <div class="row">
          <div class="col">
            <div
              class="collapse"
              id="inleveren"
              data-parent="#accordion-parrent"
            >
              <div class="card">
                <div class="card-header">
                  <a
                    class="close"
                    data-toggle="collapse"
                    data-target="#inleveren"
                    aria-expanded="false"
                    aria-controls="inleveren"
                  >
                    <span></span>
                  </a>
                  <h2>{{ lang.card_return_car.form.header }}</h2>
                </div>
                <div class="card-body">
                  <p>{{ lang.card_return_car.form.introductory }}</p>
                  <form class="mt-5">
                    <div class="row">
                      <div class="col-md-4">
                        <input
                          ref="license_plate"
                          type="text"
                          class="form-control license_plate"
                          name="license_plate"
                          :placeholder="
                            lang.card_return_car.form.input_license_plate
                          "
                          v-model="licensePlate"
                        />
                      </div>
                      <div class="col-md-4">
                        <input
                          ref="conked_out_license_plate"
                          type="text"
                          class="form-control"
                          name="conked_out_license_plate"
                          :placeholder="
                            lang.card_return_car.form
                              .input_license_plate_customer
                          "
                          @keyup.prevent.enter="handleSignOffVehicle"
                          v-model="coLicensePlate"
                        />
                      </div>
                      <div class="col-md-4">
                        <input
                          type="button"
                          class="btn btn-primary"
                          :value="lang.card_return_car.form.btn_submit"
                          @click="handleSignOffVehicle"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="collapse" id="search" data-parent="#accordion-parrent">
              <div class="card">
                <div class="card-header">
                  <a
                    class="close"
                    data-toggle="collapse"
                    data-target="#search"
                    aria-expanded="false"
                    aria-controls="search"
                  >
                    <span></span>
                  </a>
                  <h2>{{ lang.card_drop_off_location.form.header }}</h2>
                </div>
                <div class="card-body">
                  <p>{{ lang.card_drop_off_location.form.introductory }}</p>
                  <form class="mt-5">
                    <div class="row">
                      <div class="col-md-4">
                        <input
                          autofocus
                          type="text"
                          class="form-control"
                          :placeholder="
                            lang.card_drop_off_location.form.input_license_plate
                          "
                          v-model="returnLicensePlate"
                          @keydown.prevent.enter="handleFindReturnDepots"
                        />
                      </div>
                      <div class="col-md-4">
                        <input
                          type="button"
                          class="btn btn-primary return_license_plate"
                          :value="lang.card_drop_off_location.form.btn_submit"
                          @click="handleFindReturnDepots"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div
              class="collapse"
              id="rental-extension"
              data-parent="#accordion-parrent"
            >
              <div class="card">
                <div class="card-header">
                  <a
                    class="close"
                    data-toggle="collapse"
                    data-target="#rental-extension"
                    aria-expanded="false"
                    aria-controls="rental-extension"
                  >
                    <span></span>
                  </a>
                  <h2>{{ lang.card_rental_extension.form.header }}</h2>
                </div>
                <div class="card-body">
                  <p>{{ lang.card_rental_extension.form.introductory }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container h-100">
        <div class="row h-100">
          <div class="col-xl-4 col-lg-8 align-self-center">
            <h2 class="text-white">{{ lang.nutshell.header }}</h2>
            <p class="text-white">{{ lang.nutshell.introductory_1 }}</p>
            <p class="text-white">{{ lang.nutshell.introductory_2 }}</p>
          </div>
        </div>
      </div>

      <div class="illustration-3">
        <div class="img"></div>
        <div class="border"></div>
      </div>

      <div class="illustration-4">
        <div class="img"></div>
        <div class="border"></div>
      </div>

      <div class="illustration-5">
        <div class="img"></div>
        <div class="border"></div>
      </div>
    </section>

    <section class="footer">
      <div class="portal wow animeted fadeInLeft"></div>
      <div class="container h-100">
        <div class="row h-100">
          <div class="col-lg-4 col-md-8 offset-lg-8 align-self-center">
            <h2>{{ lang.back_on_the_road.header }}</h2>
            <p>{{ lang.back_on_the_road.introductory }}</p>
          </div>
        </div>
      </div>
    </section>

    <section v-if="faqItems.length || videos.length" id="faq" class="faq">
      <div class="container">
        <div v-if="faqItems.length" class="faq-block">
          <header class="faq-intro text-left text-md-center">
            <h3>{{ lang.faq.header }}</h3>
            <p>{{ lang.faq.subtitle }}</p>
          </header>
          <div class="faq-column">
            <ul class="faq-list">
              <li
                v-for="item in faqItems"
                :key="`faq-${item.id}`"
                class="faq-item"
                :lang="item.locale"
                :class="{ 'is-open': isFaqOpen(item.id) }"
              >
                <h4 class="faq-heading">
                  <button
                    :id="`faq-question-${item.id}`"
                    type="button"
                    class="faq-question"
                    :aria-expanded="isFaqOpen(item.id) ? 'true' : 'false'"
                    :aria-controls="`faq-answer-${item.id}`"
                    @click="toggleFaq(item.id)"
                  >
                    <span class="faq-question-text">{{ item.question }}</span>
                    <span class="faq-chevron" aria-hidden="true"></span>
                  </button>
                </h4>
                <div
                  :id="`faq-answer-${item.id}`"
                  class="faq-answer"
                  role="region"
                  :aria-labelledby="`faq-question-${item.id}`"
                >
                  <div class="faq-answer-body" v-html="item.answer"></div>
                </div>
              </li>
            </ul>
            <p class="faq-cta">
              {{ lang.faq.cta }}
              <a href="#contact" @click.prevent="scrollToContact">{{ lang.faq.cta_link }}</a>
            </p>
          </div>
        </div>
        <div v-if="videos.length" class="faq-block">
          <header class="faq-intro text-left text-md-center">
            <h3>{{ lang.faq.videos_header }}</h3>
            <p>{{ lang.faq.videos_subtitle }}</p>
          </header>
          <div class="faq-videos" :class="{ 'is-single': videos.length === 1 }">
            <figure
              v-for="video in videos"
              :key="`video-${video.id}`"
              class="faq-video"
            >
              <div class="faq-video-frame embed-responsive embed-responsive-16by9">
                <iframe
                  class="embed-responsive-item"
                  :src="video.embed_url"
                  :title="video.title"
                  loading="lazy"
                  allow="encrypted-media; picture-in-picture; fullscreen"
                  allowfullscreen
                ></iframe>
              </div>
              <figcaption>{{ video.title }}</figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>

    <section id="contact">
      <div class="container">
        <div class="row mb-5">
          <div class="col-md-8 offset-md-2 text-left text-md-center">
            <h3>{{ lang.contact.header_1 }}</h3>
            <h3>{{ lang.contact.header_2 }}</h3>
          </div>
        </div>
        <div class="flex justify-center flex-wrap gap-x-4 gap-y-4 w-100 mb-4">
          <div class="flex-nogrow">
            <a href="tel:+310850206800" class="btn btn-primary"
              >+31 (0) 85 020 6800</a
            >
          </div>
          <div class="flex-nogrow">
            <a href="mailto:rent@rentrunner.eu" class="btn btn-primary"
              >rent@rentrunner.eu</a
            >
          </div>
        </div>
        <div class="flex justify-center flex-wrap gap-x-4 gap-y-4 w-100 mb-4">
          <div class="flex-nogrow">
            <router-link tag="a" to="/privacy-statement" class="btn btn-primary"
              >Privacy Statement</router-link
            >
          </div>
          <div class="flex flex-nogrow">
            <router-link tag="a" to="/user-agreement" class="btn btn-primary"
              >Gebruikersvoorwaarden</router-link
            >
          </div>
        </div>
      </div>
      <div>
        <img class="bovag-logo" src="/overt/img/bovag.png" />
      </div>
    </section>

    <!-- <script src="/overt/js/wow.js"></script>
    <script src="/overt/js/index.js"></script>-->
  </div>
</template>

<script>
// import "~overt/js/index";
import * as Sentry from "@sentry/vue";
import { isCrossOriginFrameError } from "@/helpers/isCrossOriginFrameError";

export default {
  name: "landing",
  data() {
    return {
      licensePlate: "",
      returnLicensePlate: "",
      coLicensePlate: "",
      faqItems: [],
      videos: [],
      openFaqIds: [],
      lang: i18n.app.components.welcome
    };
  },
  created() {
    this.loadFaq();
  },
  mounted() {
    const vueClass = this;

    jQuery(function($) {
      const hash = window.location.hash;
      var header = $("#header");

      $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 100) {
          header.addClass("scroll");
        } else {
          header.removeClass("scroll");
        }
      });

      // init WOW. Cookiebot's iframe can throw SecurityError if WOW/jQuery
      // inspects a cross-origin frame while scanning the landing DOM (RR-362).
      if (typeof WOW !== "undefined") {
        try {
          new WOW().init();
        } catch (e) {
          if (!isCrossOriginFrameError(e)) throw e;
        }
      }

      // Parallax
      $(window).scroll(function(e) {
        parallax();
      });

      function parallax() {
        listOfItems();
      }

      function addItem(item, speed, direction) {
        let scrolled = $(window).scrollTop();
        item.css(direction, -(scrolled * speed) + "px");
      }

      function listOfItems() {
        addItem($(".illustration-4"), 0.1, "margin-top");
        addItem($(".illustration-2"), 0.5, "margin-top");
        addItem($(".illustration-3"), 0.3, "margin-top");
      }

      // Smooth scroll
      $('a[href*="#"]:not([href="#"]):not([data-toggle])').click(function() {
        if (
          location.pathname.replace(/^\//, "") ==
            this.pathname.replace(/^\//, "") &&
          location.hostname == this.hostname
        ) {
          var target = $(this.hash);
          vueClass.scrollToElement(target);
        }
      });

      if (hash) {
        const element = document.getElementById(hash.replace("#", ""));

        if (element) {
          const $element = jQuery(element);
          $element.click();

          if ($element.hasClass("collapse")) {
            $element.addClass("show");
          }
        }
      }
    });
  },
  methods: {
    async loadFaq() {
      try {
        const { data } = await axios.get("/api/faq");
        this.faqItems = data.items;
        this.videos = data.videos;
      } catch (e) {
        Sentry.captureException(e);
      }
    },
    isFaqOpen(id) {
      return this.openFaqIds.includes(id);
    },
    toggleFaq(id) {
      this.openFaqIds = this.isFaqOpen(id)
        ? this.openFaqIds.filter(openId => openId !== id)
        : [...this.openFaqIds, id];
    },
    scrollToElement($element) {
      $element = $element.length
        ? $element
        : $("[name=" + this.hash.slice(1) + "]");
      if ($element.length) {
        $("html, body").animate(
          {
            scrollTop: $element.offset().top
          },
          1000
        );
        return false;
      }
    },

    scrollToContact() {
      this.scrollToElement(jQuery("#contact"));
    },

    onAccodionItemClick(event) {
      this.scrollToElement(jQuery(this.$refs.accordion));
    },
    onPrivacyStatementClick() {
      this.$router.push({
        name: "privacy-statement"
      });
    },

    async handleSignOffVehicle() {
      const success = await this.checkLicensePlates(
        this.licensePlate,
        this.coLicensePlate
      );
      if (success) {
        location.href = `/sign-off-form?license_plate=${this.licensePlate}&co_license_plate=${this.coLicensePlate}`;
      } else {
        $(".license_plate").addClass("license-error");
      }
    },
    async handleFindReturnDepots() {
      const success = await this.checkLicensePlate(this.returnLicensePlate);
      if (success) {
        location.href = `/return-locations`;
      } else {
        $(".return_license_plate").addClass("license-error");
      }
    },
    async checkLicensePlate(licensePlate) {
      if (licensePlate !== "") {
        return await axios
          .post("/sign-off/check-license-plate", {
            license_plate: licensePlate
          })
          .then(() => true)
          .catch(() => false);
      } else {
        return false;
      }
    },
    async checkLicensePlates(licensePlate, coLicensePlate) {
      if (licensePlate !== "") {
        return await axios
          .post("/sign-off/check-license-plates", {
            license_plate: licensePlate,
            co_license_plate: coLicensePlate
          })
          .then(() => true)
          .catch(() => false);
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "*/overt/scss/main.scss";

.bovag-logo {
  width: 100%;
  max-width: 80px;
  margin: 0 auto;
  display: block;
}

$faq-radius: $spacer * 0.5;
$faq-shadow: 0 0.2rem 1.2rem rgba($black, 0.06);
$faq-touch-target: 44px;
$faq-measure: 65ch;
$faq-motion: 0.25s ease-in-out;

.faq {
  background: $grey;
  padding: $spacer * 4 0;
  margin-bottom: $spacer * 3;
}

.faq-block + .faq-block {
  margin-top: $spacer * 4;
}

.faq-intro {
  max-width: $faq-measure;
  margin: 0 auto $spacer * 2;

  h3 {
    margin-bottom: $spacer * 0.5;
  }

  p {
    margin: 0;
    color: $gray-700;
  }
}

.faq-column {
  max-width: 80rem;
  margin: 0 auto;
}

.faq-list {
  display: grid;
  gap: $spacer * 0.5;
  list-style: none;
  margin: 0;
  padding: 0;
}

.faq-item {
  background: $body-bg;
  border: $border-width solid $border-color;
  border-radius: $faq-radius;
  overflow: hidden;
  transition: border-color $faq-motion, box-shadow $faq-motion;

  &:hover,
  &.is-open {
    border-color: $gray-400;
  }

  &.is-open {
    box-shadow: $faq-shadow;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
}

.faq-heading {
  margin: 0;
  font-size: $font-size-base;
}

.faq-question {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: calc(#{$faq-touch-target} + #{$spacer});
  padding: $spacer * 0.5 $spacer * 0.5 $spacer * 0.5 $spacer;
  border: 0;
  background: transparent;
  color: $headings-color;
  font-family: $primaryFont;
  font-size: $primaryFontSize;
  font-weight: $font-weight-semibold;
  line-height: 1.4;
  text-align: left;
  cursor: pointer;
  border-radius: calc(#{$faq-radius} - #{$border-width});

  @include media-breakpoint-up(md) {
    padding-left: $spacer * 1.5;
  }

  .is-open & {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  // theme-overrides.scss gives every focused button a drop shadow and outline, both !important.
  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }

  &:focus-visible {
    outline: 2px solid $primary !important;
    outline-offset: -2px;
  }
}

.faq-question-text {
  flex: 1 1 auto;
  min-width: 0;
  overflow-wrap: anywhere;
}

.faq-chevron {
  position: relative;
  flex: 0 0 auto;
  width: $faq-touch-target;
  height: $faq-touch-target;
  margin-left: $spacer * 0.5;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0.9rem;
    height: 0.9rem;
    border-right: 2px solid $primary;
    border-bottom: 2px solid $primary;
    transform: translate(-50%, -75%) rotate(45deg);
    transition: transform $faq-motion;
  }

  .is-open &::before {
    transform: translate(-50%, -25%) rotate(225deg);
  }

  @media (prefers-reduced-motion: reduce) {
    &,
    &::before {
      transition: none;
    }
  }
}

.faq-answer {
  display: grid;
  grid-template-rows: 0fr;
  visibility: hidden;
  transition: grid-template-rows $faq-motion, visibility $faq-motion;

  .is-open & {
    grid-template-rows: 1fr;
    visibility: visible;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
}

.faq-answer-body {
  min-height: 0;
  overflow: hidden;
  padding: 0 $spacer;
  color: $body-color;
  font-weight: $font-weight-normal;
  overflow-wrap: anywhere;

  @include media-breakpoint-up(md) {
    padding: 0 $spacer * 1.5;
  }

  ::v-deep {
    > :first-child {
      margin-top: 0;
    }

    > :last-child {
      margin-bottom: $spacer;
    }

    p,
    ul,
    ol {
      max-width: $faq-measure;
      margin-bottom: $spacer * 0.75;
    }

    ul,
    ol {
      padding-left: $spacer;
    }

    li + li {
      margin-top: $spacer * 0.25;
    }
  }
}

.faq-cta {
  margin: $spacer * 1.5 0 0;
  color: $gray-700;
  text-align: center;

  a {
    font-weight: $font-weight-semibold;
  }
}

.faq-videos {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: $spacer * 1.5;
}

.faq-video {
  flex: 1 1 100%;
  margin: 0;

  @include media-breakpoint-up(md) {
    flex: 0 1 calc(50% - #{$spacer * 0.75});
  }

  .is-single & {
    flex-basis: 72rem;
    max-width: 72rem;
  }

  figcaption {
    margin-top: $spacer * 0.5;
    color: $headings-color;
    font-weight: $font-weight-semibold;
    text-align: center;
  }
}

.faq-video-frame {
  border-radius: $faq-radius;
  background: $black;
  box-shadow: $faq-shadow;
}
</style>
